<template>
  <page :title="$tc('activity_log._name')" size="is-tablet">
    <infinite-scroll :collection="logs">
      <div class="box" v-for="log in logs.data" :key="log.id">
        <div class="media">
          <div class="media-left">
            <user-image :user="log.causer"></user-image>
          </div>

          <div class="media-content">
            <span class="tag">#{{ log.log_name }}</span>

            <div>
              <router-link
                v-if="log.causer"
                :to="'/users/' + log.causer.id"
                class="has-text-weight-semibold"
              >{{ log.causer.email }}</router-link>

              <span v-if="log.subject">
                <span>»</span>

                <router-link
                  v-if="log.subject_type === 'App\\Selling\\Invoice'"
                  :to="'/invoices/' + log.subject.id"
                >{{ log.subject.number }}</router-link>

                <router-link
                  v-if="log.subject_type === 'App\\Publishing\\Publication'"
                  :to="'/publications/' + log.subject.id + '/edit'"
                >{{ log.subject.title }}</router-link>

                <router-link
                  v-if="log.subject_type === 'App\\Publishing\\Publisher'"
                  :to="'/publishers/' + log.subject.id"
                >{{ log.subject.name }}</router-link>
              </span>

              <p class="has-text-grey">{{ log.created_at }}</p>
            </div>

            <p>{{ log.description }}</p>
          </div>
        </div>
      </div>

      <div v-if="logs.data.length === 0" class="box">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>{{$tc('Nothinghere')}}</p>
          </div>
        </section>
      </div>
    </infinite-scroll>
  </page>
</template>

<script>
import InfiniteScroll from "./../../../../components/InfiniteScroll";
import UserImage from "./../../../../components/UserImage";

export default {
  components: {
    InfiniteScroll,
    UserImage
  },

  data() {
    return {
      logs: new window.LazyLoadingRemoteCollection("/admin/api/activity-log")
    };
  }
};
</script>
